<template>
  <div class="container mb-4">
    <h1 class="mt-3">Book search</h1>

    <p class="my-3">
      This is a book search site.
      You can search for a book by title or author.
    </p>

    <div class="form-row">
      <label class="col-form-label" for="searchSel">Search by:</label>
      <div class="form-group col-md-2">
        <select class="custom-select form-control"
          id="searchSel"
          title="Select search option"
          v-model="selected">
          <option>Title</option>
          <option>Author</option>
        </select>
      </div>
      <div class="form-group col-md-4">
        <input class="form-control"
          title="Enter search term"
          type="text"
          v-model.trim="term"
          placeholder="Search...">
      </div>
      <div class="form-group col-md-2">
        <button class="btn btn-primary"
          title="Search"
          type="submit"
          v-on:click="search">
          Submit
        </button>
      </div>
    </div>

    <section v-if="errored">
      <p>Failed to load books.</p>
    </section>
    <section v-else class="mt-2">
      <div v-if="loading">Loading...</div>
      <div v-else-if="noBooks">No books to show.</div>
      <div v-else class="row">
        <div class="mb-3" v-for="book in books" :key="book.title">
          <div class="col-md-3">
            <div class="card" style="width: 18em;">
              <img class="card-img-top" :src="`${book.cover}`">
              <div class="card-body d-flex flex-column pt-1 pb-3 px-3">
                <div class="scroll-title px-1">
                  <h5 class="card-title">{{ book.title }}</h5>
                </div>
                <div class="scroll-authors px-1">
                  <h6 class="card-subtitle mt-1 mb-2 text-muted">{{ book.authors }}</h6>
                </div>
                <div class="scroll-text px-1">
                  <p class="card-text">{{ book.description }}</p>
                </div>
                <a class="btn btn-primary mt-auto" :href="`${book.preview}`">Preview</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>
<script>
import axios from 'axios'

export default {
  name: 'BookSearch',
  data () {
    return {
      selected: 'Title',
      term: '',
      books: [],
      loading: false,
      noBooks: false,
      errored: false
    }
  },
  methods: {
    search: function () {
      const term = this.term.toLowerCase();
      if (!term) {
        return;
      }
      if (this.books.length > 0) {
        this.books = [];
      }
      if (this.noBooks) {
        this.noBooks = false;
      }
      if (this.errored) {
        this.errored = false;
      }
      if (localStorage.getItem(term)) {
        const parsed = this.getParsedData(JSON.parse(localStorage.getItem(term)));
        if (parsed.length > 0) {
          this.books = parsed;
        } else {
          this.noBooks = true;
        }
      } else {
        this.loading = true;
        axios.get('https://www.googleapis.com/books/v1/volumes', {
          params: {
            q: term
          }
        })
        .then(response => {
          if ('items' in response.data) {
            localStorage.setItem(term, JSON.stringify(response.data.items));
            const parsed = this.getParsedData(response.data.items);
            if (parsed.length > 0) {
              this.books = parsed;
            } else {
              this.noBooks = true;
            }
          } else {
            this.noBooks = true;
          }
        })
        .catch(err => {
          console.error(err);
          this.errored = true;
        })
        .finally(() => this.loading = false);
      }
    },
    getParsedData: function (data) {
      const term = this.term.toLowerCase();
      const parsed = [];
      if (this.selected === 'Title') {
        for (let i = 0; i < data.length; ++i) {
          if ('volumeInfo' in data[i] && 'title' in data[i].volumeInfo &&
            data[i].volumeInfo.title.toLowerCase().includes(term)) {
            let authors = '';
            if ('authors' in data[i].volumeInfo) {
              authors = this.getAuthors(data[i]);
            }
            parsed.push(this.getBookData(data[i], authors));
          }
        }
      } else if (this.selected === 'Author') {
        for (let i = 0; i < data.length; ++i) {
          if ('volumeInfo' in data[i] && 'title' in data[i].volumeInfo &&
            'authors' in data[i].volumeInfo && this.isAuthor(data[i].volumeInfo.authors, term)) {
            parsed.push(this.getBookData(data[i], this.getAuthors(data[i])));
          }
        }
      }
      return parsed.sort((a, b) => a.title.localeCompare(b.title));
    },
    getBookData: function (data, authors) {
      const year = 'publishedDate' in data.volumeInfo &&
        this.isValidYear(data.volumeInfo.publishedDate.substring(0, 4)) ?
        ' (' + data.volumeInfo.publishedDate.substring(0, 4) + ')' : '';
      return {
        cover: 'imageLinks' in data.volumeInfo && 'thumbnail' in data.volumeInfo.imageLinks ?
          data.volumeInfo.imageLinks.thumbnail : '',
        title: data.volumeInfo.title,
        authors: authors += year,
        description: 'description' in data.volumeInfo ? data.volumeInfo.description : '',
        preview: 'previewLink' in data.volumeInfo ? data.volumeInfo.previewLink : ''
      }
    },
    getAuthors: function (data) {
      let authors = '';
      for (let i = 0; i < data.volumeInfo.authors.length; ++i) {
        authors += data.volumeInfo.authors[i];
        authors += i + 1 < data.volumeInfo.authors.length ? ', ' : '';
      }
      return authors;
    },
    isAuthor: function (authors, author) {
      for (let i = 0; i < authors.length; ++i) {
        if (authors[i].toLowerCase().includes(author)) {
          return true;
        }
      }
      return false;
    },
    isValidYear: function (year) {
      const date = '01-01-' + year;
      if (date.match(/^\d{2}([-])\d{2}\1\d{4}$/)) {
        return true;
      } else {
        return false;
      }
    }
  }
}
</script>
<style scoped>
.btn {
  width: 6rem;
}

.btn:focus {
  box-shadow: none !important;
}

.card {
  height: 760px;
}

.card-img-top {
  height: calc(18em * (192 / 128));
}

.scroll-title {
  max-height: 80px;
  overflow-y: auto;
}

.scroll-authors {
  max-height: 60px;
  overflow-y: auto;
}

.scroll-text {
  max-height: 120px;
  overflow-y: auto;
}
</style>
